import { render, staticRenderFns } from "./CustomerActivityDisplayCommentItem.vue?vue&type=template&id=1717a6e1"
import script from "./CustomerActivityDisplayCommentItem.vue?vue&type=script&lang=js"
export * from "./CustomerActivityDisplayCommentItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports